export const reorderUpdateDelete = {
  state: {
    items: [],
    newItems: [],
  },
  getters: {
    items(state) {
      return state.items;
    },
    newItems(state) {
      return state.newItems;
    },
    allItems(state) {
      const activeOld = state.items.filter(x => !x.delete);
      const activeNew = state.newItems.filter(x => !x.delete);
      const items = [...activeOld, ...activeNew];
      items.sort((a, b) => a.order - b.order);
      return items;
    },
  },
  mutations: {
    incrementNewItems(state, order) {
      state.newItems.push({ order, new: true });
    },

    updateItem(state, payload) {
      const { index, key, value } = payload;
      for (let x of state.items) {
        if (x.order === index) {
          x[key] = value;
          x['update'] = true;
        }
      }
    },

    updateNewItem(state, payload) {
      const { index, key, value } = payload;
      for (let x of state.newItems) {
        if (x.order === index) {
          x[key] = value;
        }
      }
    },

    markItemForDelete(state, index) {
      for (let x of state.items) {
        if (x.order === index) {
          x['delete'] = true;
          x.order = undefined;
        }
      }

      for (let x of state.items) {
        if (x.order > index) {
          x.order--;
        }
      }

      for (let x of state.newItems) {
        if (x.order > index) {
          x.order--;
        }
      }
    },

    deleteNewItem(state, index) {
      for (let [i, x] of state.newItems.entries()) {
        if (x.order === index) {
          state.newItems.splice(i, 1);
        }
      }

      for (let x of state.items) {
        if (x.order > index) {
          x.order--;
        }
      }

      for (let x of state.newItems) {
        if (x.order > index) {
          x.order--;
        }
      }
    },

    sortItems(state) {
      state.items.sort((a, b) => {
        return a.order - b.order;
      });
    },

    clearItems(state) {
      state.newItems = [];
    },

    updateItemOrder(state, { i, value }) {
      state.items[i]['order'] = value;
      state.items[i]['update'] = true;
    },

    updateNewItemOrder(state, { i, value }) {
      state.newItems[i]['order'] = value;
    },
  },
  actions: {
    addNewItem({ commit, dispatch }, amount) {
      commit('incrementNewItems', amount);
      dispatch('addDirtyTab');
    },

    updateItem({ commit, dispatch }, payload) {
      commit('updateItem', payload);
      dispatch('addDirtyTab');
    },

    updateNewItem({ commit, dispatch }, payload) {
      commit('updateNewItem', payload);
      dispatch('addDirtyTab');
    },

    removeItem({ commit, dispatch }, index) {
      commit('markItemForDelete', index);
      dispatch('addDirtyTab');
    },

    removeNewItem({ commit }, index) {
      commit('deleteNewItem', index);
    },

    changeOrder({ commit, dispatch, state }, payload) {
      let clicked;
      let alter;

      const clickedValue = payload.index + payload.direction;

      for (let [i, x] of state.newItems.entries()) {
        if (x.order === payload.index) {
          clicked = { new: true, i, value: clickedValue };
        }
      }

      for (let [i, x] of state.items.entries()) {
        if (x.order === payload.index) {
          clicked = { new: false, i, value: clickedValue };
        }
      }

      for (let [i, x] of state.newItems.entries()) {
        if (x.order === payload.index + payload.direction) {
          alter = { new: true, i, value: payload.index };
        }
      }

      for (let [i, x] of state.items.entries()) {
        if (x.order === payload.index + payload.direction) {
          alter = { new: false, i, value: payload.index };
        }
      }

      if (clicked.new) {
        commit('updateNewItemOrder', clicked);
      } else {
        commit('updateItemOrder', clicked);
      }

      if (alter.new) {
        commit('updateNewItemOrder', alter);
      } else {
        commit('updateItemOrder', alter);
      }

      dispatch('addDirtyTab');
    },

    clearItems({ commit }) {
      commit('clearItems');
    },
  },
};
